<template>
  <div class="web-header nav" v-html="header">
    {{ header }}
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      productStoreId: null,
      wikiSpaceId: null,
      pagePath: null,
      header: null
    }
  },
  mounted() {
    if (this.$route.query.lang) {
      this.$cookie.set('language', this.$route.query.lang, 1);
    }
    if (this.$cookie.get('language') != 'undefined') {
      this.$language = this.$cookie.get('language')
    }
    if (this.$language == 'en') { this.$language = this.$language+'_US' }
    if (this.$language == 'th') { this.$language = this.$language+'_TH' }
    this.$backendService.getStoreContentInfo(this.$productStoreId, this.$language).then (result => {
      this.productStoreId = result.data.productStore.productStoreId;
      this.templateWikiSpaceId = result.data.templateWikiSpaceId;
      this.pagePath = result.data.wikiTemplateInfo.template_client_header;
      this.$backendService.getContentHTML(this.productStoreId, this.templateWikiSpaceId, this.pagePath).then (result => {
        this.header = result.data.contentText
      })
    })
    window.openMenu = this.openMenu.bind(this);
  },
  methods: {
    openMenu () {
      var x = document.getElementById("myTopnav");
      if (x.className === "sf-menu") {
        x.className += " responsive";
      } else {
        x.className = "sf-menu";
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue